import React from 'react'
import GAUserDetailsContainer from '../../modules/GAUsers/containers/GAUserDetailsContainer/GAUserDetailsContainer'

const GAUserDetails = () => {
  return (
    <GAUserDetailsContainer />
  )
}

export default GAUserDetails